export function currentLocationHrefWithoutQuery(): string | undefined {
  if (globalThis.window === undefined) return undefined
  return `${globalThis.location.origin}${globalThis.location.pathname}`
}
